<template>
  <div class="component-wrap" :class="{'component-padded' : base.padded, 'active': active}">
    <div class="current-active"></div>
    <div v-if="base.title" class="component-header">
      <div class="component-title">
        <div>{{base.title}}</div>
        <div class="subtitle">{{base.subtitle}}</div>
      </div>
      <div class="component-more">
        <div class="three-dot"></div>
      </div>
    </div>


      <div :class="'showcase-scheme-3'">

        <div v-for="(item, index) in data" :key="index" class="scheme-item">
          <div class="layout layout-3">
          <img class="show-img" :src="wximageurl + item.imgUrl" />
          </div>
        </div>
      </div>


  </div>
</template>

<script>
  export default {
    props: {
      res: {
        type: Object,
        default: {}
      },
      active: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      res (value) {
        if (value) {
          this.setData(value)
        }
      }
    },
    data () {
      return {
        base: {},
        config: {},
        data: []
      }
    },
    methods: {
      setData(val) {
        this.base = val.base
        this.config = val.config
        this.data = val.data
      }
    },
    mounted() {
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">
  .showcase-scheme-1 {
    display: flex;
    .scheme-item {
      flex: 1;
    }
    .layout {
      position: relative;
      width: 100%;
      &::after {
        display: flex;
        content: "";
      }
      &.layout-1 {
        &::after {
          padding-top: 150%;
        }
      }
      &.layout-2 {
        &::after {
          padding-top: 85%;
        }
      }
      &.layout-3 {
        &::after {
          padding-top: 65%;
        }
      }
      .show-img {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .showcase-scheme-2 {
    display: flex;
    .scheme-item {
      flex: 1;
    }
    .layout {
      position: relative;
      width: 100%;
      &::after {
        display: flex;
        content: "";
      }
      &.layout-1 {
        &::after {
          padding-top: 150%;
        }
      }
      &.layout-2 {
        &::after {
          padding-top: 150%;
        }
      }

      .show-img {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .showcase-scheme-3 {
    display: flex;
    overflow-x: auto;white-space:nowrap;
    .scheme-item {
      flex: 1;
    }
    .layout {
      position: relative;
      width: 100%;
      &::after {
        display: flex;
        content: "";
      }
      &.layout-1 {
        &::after {
          padding-top: 150%;
        }
      }
      &.layout-2 {
        &::after {
          padding-top: 150%;
        }
      }
      &.layout-3 {
        &::after {
          padding-top: 150%;
        }
      }
      &.layout-4 {
        &::after {
          padding-top: 150%;
        }
      }

      .show-img {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// showcasebg.vue?b261d674